// extracted by mini-css-extract-plugin
module.exports = {"container":"UpdateRequirements_container__2OeSS","buttonContainer":"UpdateRequirements_buttonContainer__vcHL9","submitButton":"UpdateRequirements_submitButton__1Yjr5"};